import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createSidebar } from '../actions/SidebarActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import SidebarForm from '../components/SidebarForm';

import Configuration from '../Config';

const validation = Configuration.Validations.sidebar;
const defaults = Configuration.Defaults.createSidebar;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateSidebar extends Component {
    handleSave = (values) => {
        this.props.dispatch(createSidebar(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/sidebar">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista sidebar
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Creare Sidebar Nou
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <SidebarForm
                            isEdit={false}
                            initialValues={defaults}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors} />
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.sidebar.errors.type === 'validation' ? mapValidationErrors(state.sidebar.errors.fields) : [],
    }
}

export default connect(mapStateToProps)(CreateSidebar);
